import React, { useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Divider, Grid } from "@material-ui/core";
import clsx from "clsx";
import Typography from "@components/Typography";
import { useUserState } from "@features/User/context";
import Switch from "@components/IOSswitch";
import userApi from "@api/user";
import { ColProps_1 } from "@core/utils/ColProps";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { MarketContext } from "@context/MarketContext";
import { UpdateSettingContext } from "@context/UpdateSettingProvider";

const PopoverComponent = () => {
  const classes = useStyles();
  const user = useUserState();
  const setting = user?.user?.setting;
  const notificationSound = user?.user?.setting?.notificationSound;
  const layout = setting?.layout;
  const [soundCheck, setSoundCheck] = useState(notificationSound);
  const UpdateSetting = useContext(UpdateSettingContext);
  const [alignment, setAlignment] = useState(layout || "template2");
  const market = useContext(MarketContext);

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
    market.setLayout(newAlignment);
    userApi
      .changeUserSettings({
        payload: {
          ...setting,
          layout: newAlignment,
        },
      })
      .then((data) => {
        UpdateSetting.setUpdateUser(!UpdateSetting.updateUser);
      })
      .catch((data) => {});
  };

  useEffect(() => {
    setSoundCheck(notificationSound);
  }, [notificationSound]);

  const SoundHandleChange = () => {
    setSoundCheck(!soundCheck);
    userApi
      .changeUserSettings({
        payload: {
          ...setting,
          notificationSound: !soundCheck,
        },
      })
      .then((data) => {})
      .catch((data) => {});
  };

  const displayImages = [
    {
      value: "template1",
      src: "/static/icons/Trade - Theme Style/Light/Theme 01.png",
    },
    {
      value: "template2",
      src: "/static/icons/Trade - Theme Style/Light/Theme 02.png",
    },
    {
      value: "template3",
      src: "/static/icons/Trade - Theme Style/Light/Theme 03.png",
    },
  ];

  return (
    <Grid container direction="column" spacing={10}>
      <Grid item container direction="row" justify="space-between">
        <Grid item className={classes.iconContainer}>
          <span className={clsx("icon-bell", classes.icon)} />
          <Typography>{__t("The sound of notifications")}</Typography>
        </Grid>
        <Grid item>
          <Switch
            beforeLabel
            withoutLabel={true}
            variant="onOrOff"
            checked={soundCheck}
            setChecked={SoundHandleChange}
          />
        </Grid>
      </Grid>
      <Grid item {...ColProps_1}>
        <Divider className={classes.divider} />
      </Grid>
      <Grid item direction="row" className={classes.iconContainer}>
        <span className={clsx("icon-layout", classes.icon)} />
        <Typography>{__t("How to display")}</Typography>
      </Grid>

      <ToggleButtonGroup
        value={alignment}
        exclusive
        onChange={handleAlignment}
        className={classes.ToggleButtonGroup}
      >
        {displayImages.map((item) => (
          <ToggleButton value={item.value} className={classes.ToggleButton}>
            <img src={item.src} className={classes.displayImage} />
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Grid>
  );
};

export default PopoverComponent;
